import { atom, useAtom } from "jotai";
import Modal from "@xtribe/shared/components/lib/Modal";
import MediaFileDropzone from "./FileDropzone";
import { useEffect } from "react";
import MediaUploadToast from "./MediaUploadToast";

export const uploadModalOpenAtom = atom(false);
export const uploadFilesAtom = atom<File[]>([]);

const MediaUploadModal = () => {
  const [open, setOpen] = useAtom(uploadModalOpenAtom);
  const [files, setFiles] = useAtom(uploadFilesAtom);
  const handler = () => setOpen(true);
  const closeHandler = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (files.length > 0 && !open) {
    }
  }, [open, files]);
  const uploadFiles = (files: File[]) => {
    console.log(files);
    setTimeout(() => {
      setFiles(files);
    }, 300);
  };
  return (
    <>
      <Modal open={open} onClose={closeHandler} width="42rem">
        <Modal.Title>Upload</Modal.Title>
        <Modal.Content>
          <MediaFileDropzone uploadFiles={uploadFiles} />
        </Modal.Content>
      </Modal>
      {files.length > 0 && !open ? <MediaUploadToast /> : null}
    </>
  );
};

export default MediaUploadModal;
